import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { Divider } from '@material-ui/core'
import {styles} from '../../CSS/Styles'
import TextField from '@material-ui/core/TextField'
import Checkbox from '@material-ui/core/Checkbox'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import SimpleSelect from '../../CSSComponent/dropdownselection'
import Button from '@material-ui/core/Button'

class RiskInformation extends React.Component {

    constructor(props) {
        super(props)
        let riskowner = this.props.riskOwner['Risk Owners']
        let risksupportor = this.props.riskOwner['Supported by']
        console.log(this.props.riskOwner)
        let owners = []
        let supportor = []

        for (let item in riskowner) {
            owners.push(riskowner[item].risk_owners + ', ' + riskowner[item].risk_owners_designation)
        }
        for (let item in risksupportor) {
            supportor.push(risksupportor[item].risk_owners + ', ' + risksupportor[item].risk_owners_designation)
        }



        this.state = {
            'RiskDescription': this.props.RiskDescription,
            'Strategic': this.props.Strategic,
            'Operational': this.props.Operational,
            'Compliance': this.props.Compliance,
            'Financial': this.props.Financial,
            'Technology': this.props.Technology,
            'ABCEntity': this.props.ABCEntity,
            'ABBEntity': this.props.ABBEntity,
            'ACCEntity': this.props.ACCEntity,
            'Risk Owners': owners,
            'Supported by': supportor
        }
    }

    componentDidUpdate(prevProps) {
        // console.log("new id : " + this.props.queryID + "vs old id : " + prevProps.queryID);
        if (this.props !== prevProps) {
            //console.log("queryID changed from "+ prevProps.riskname + " to " +this.props.riskname)
            console.log("peops changede")
            let riskowner =this.props.riskOwner['Risk Owners']
            let risksupportor = this.props.riskOwner['Supported by']
            let owners = []
            let supportor = []
            
            for (let item in riskowner) {
                owners.push(riskowner[item].risk_owners + ', ' + riskowner[item].risk_owners_designation)
            }
            for (let item in risksupportor) {
                supportor.push(risksupportor[item].risk_owners + ', ' + risksupportor[item].risk_owners_designation)
            }
            console.log(owners)


            this.setState({
                'RiskDescription': this.props.RiskDescription,
                'Strategic': this.props.Strategic,
                'Operational': this.props.Operational,
                'Compliance': this.props.Compliance,
                'Financial': this.props.Financial,
                'Technology': this.props.Technology,
                'ABCEntity': this.props.ABCEntity,
                'ABBEntity': this.props.ABBEntity,
                'ACCEntity': this.props.ACCEntity,
                'Risk Owners': owners,
                'Supported by': supportor
            })
        }
    }
    handleListSelect = (key, value, index) => {
        console.log(key, value)
        this.setState((state)=>{ this.state[key][index] = value }, ()=>{
            this.props.submitOwnerChange(key, this.state[key])
        })
    };

    handleTextChange = (name, event) => {
        //console.log(this.Risk_info_temp)
        this.setState({ [name]: event.target.value })
        this.props.submitChange(name, event.target.value)
    };

    handleChange = name => event => {
        this.setState({ [name]: event.target.checked ? '✔' : null },()=>{
            let databsename = name
            if (name == 'ABCEntity') {
                databsename = 'NETS Entity'
            } else if (name == 'ABBEntity') {
                databsename = 'BCS Entity'
            } else if (name == 'ACCEntity') {
                databsename = 'BCSIS Entity'
            }
            this.props.submitChange(databsename, this.state[name])
        })
        //console.log(name)
    };

    handleAddNew = (event) => {
        // get the type (as data-value in the dom element), here need to use its parent, because the event target return only the button not its wrapper
        let type = event.target.parentNode.dataset.value
        // if click on the border of the button, it returns the parents........
        if (type == null) {
            type = event.target.dataset.value
        }
        let updateList = this.state[type]
        if(updateList == null) {
            updateList = []
        }
        updateList.push("")
        this.setState({ [type]: updateList }, ()=>{
            this.props.submitOwnerChange(type, updateList)
        })
    }

    handleDrop = (event) => {
        let riskOwnerType = event.target.parentNode.dataset.value
        let index = event.target.parentNode.dataset.index
        // if click on the border of the button, it returns the parents........
        if (riskOwnerType == null) {
            riskOwnerType = event.target.dataset.value
            index = event.target.dataset.index
        }
        console.log(riskOwnerType, index)
        let updateList = this.state[riskOwnerType]
        updateList.splice(index, 1)
        this.setState({[riskOwnerType]: updateList}, ()=>{
            this.props.submitOwnerChange(riskOwnerType, updateList)
        })


    }


    render() {
        const { classes } = this.props;
        const filters = (filterdata)=>{
            let filterJSX = []
            for (var filter in filterdata) {
                filterJSX.push(
                    <div style={{ textAlign: 'left', paddingLeft: '10px'}}>
                        <Typography variant='h7' style={{ display: 'inline-block', minWidth: '120px'}}> {filter} </Typography>
                        {filterdata[filter].map((data)=>{
                            return (
                                <div style={{display:'inline-block', textAlign:'left', minWidth:'120px'}}>
                                    <Checkbox
                                        checked={this.state[data.replace(' ','')]=='✔'}
                                        onChange={this.handleChange(data.replace(' ',''))}
                                        value={data.replace(' ','')}
                                        color='primary'
                                    />
                                    <typography> {data} </typography>
                                </div>
                            )
                        })}
                    </div>
                )
            }
            return filterJSX
        }
        const RiskInfocheckboxSelection = filters(this.props.filter)

        const selectlist = (data)=>{
            let filterJSX = []
            //console.log(namelist)
            // console.log(data)
            for (var riskOwner in data) {
                filterJSX.push(
                    <div style={{ textAlign: 'left', paddingLeft: '10px'}}>
                        <typography style={{ display: 'inline-block', minWidth: '160px', verticalAlign:"top", paddingTop:"10px"}}> {riskOwner} </typography>

                        <div style={{display:'inline-block', textAlign:'left', minWidth:'120px'}}>
                            <List>
                                {data[riskOwner].map((dataitem, index)=>{
                                    //console.log(dataitem)
                                    return (
                                        <ListItem style = {{padding:0}}>
                                            <SimpleSelect
                                                id = {riskOwner.split(':')[0]}
                                                option = {this.props.namelist}
                                                index = {index}
                                                defaultoption={this.props.namelist.findIndex(item => item == dataitem)}
                                                returnSelection={this.handleListSelect}
                                            />
                                            <Button
                                                data-value={riskOwner}
                                                data-index={index}
                                                variant='outlined'
                                                color='secondary'
                                                className={classes.button}
                                                onClick= {this.handleDrop}
                                            >
                                                Drop
                                            </Button>
                                        </ListItem>
                                    )
                                })}
                            </List>
                        </div>

                        <div style={{ display: 'block', paddingLeft: '160px' }}>
                            <Button data-value={riskOwner} variant="outlined" color="primary" className={classes.button} onClick= {this.handleAddNew}>
                                Add New
                            </Button>
                        </div>
                    </div>
                )
            }
            return filterJSX
        }
        console.log({'Risk Owners': this.state['Risk Owners'], 'Supported by': this.state['Supported by']})
        const risklistEdit = selectlist({'Risk Owners': this.state['Risk Owners'], 'Supported by': this.state['Supported by']})

        return(
            <div>
                <Typography variant = "h6"  align = "left" className={classes.FormHeader}> A. Risk Information </Typography>
                <Divider className={classes.FormDivider}/>
                <TextField
                    id = "RiskDescription"
                    fullWidth = "true"
                    variant = "outlined"
                    multiline = "true"
                    className={classes.FormTextField}
                    onChange = {(event) => this.handleTextChange("RiskDescription",event)}
                    value = {this.state.RiskDescription}
                    placeholder = "click to edit"
                />
                {RiskInfocheckboxSelection}
                {risklistEdit}

            </div>
                    
        )
    }
}

export default withStyles(styles)(RiskInformation);
    


// WEBPACK FOOTER //
// ./src/components/Risks/RiskRegisterSection/A.js